import React from 'react';

export default function Projects () {
    return (
        <div>
            <h1>Projects</h1>
        </div>
    );
};
